export const citationStyles: { key: string; value: string }[] = [
  {
    key: 'american-medical-association',
    value: 'AMA',
  },
  {
    key: 'apa',
    value: 'APA',
  },
  {
    key: 'chicago-fullnote-bibliography',
    value: 'Chicago',
  },
  {
    key: 'frontiers',
    value: 'Frontiers',
  },
  {
    key: 'harvard-cite-them-right',
    value: 'Harvard',
  },
  {
    key: 'ieee',
    value: 'IEEE',
  },
  {
    key: 'springer-lecture-notes-in-computer-science',
    value: 'LNCS',
  },
  {
    key: 'modern-language-association',
    value: 'MLA',
  },
];

export const citationLocales: Record<string, string> = {
  de: 'de-DE',
  en: 'en-US',
};
